import { useRef, useEffect, useState, useCallback } from "react";
import BpmnViewer from 'bpmn-js/lib/Viewer';

const scaleMax = 1.5;

const fitViewport = (bpmn) => {
    const canvas = bpmn.get("canvas");
    let vbox = canvas.viewbox();
    if (vbox.height === 0 || vbox.width === 0) {
        canvas.zoom("fit-viewport");
        vbox = canvas.viewbox();
        // we give up should be hidden
        if (vbox.height === 0 || vbox.width === 0) {
            return;
        }
    }
    const outer = vbox.outer,
        inner = vbox.inner,
        newScale = Math.min(outer.width / inner.width, outer.height / inner.height),
        newViewbox = {
            x: inner.x,
            y: inner.y,
            width: outer.width / newScale,
            height: outer.height / newScale
        };
    canvas.viewbox(newViewbox);
    if (newScale > scaleMax) {
        let vbox = canvas.viewbox();
        const outer = vbox.outer,
            inner = vbox.inner,
            newViewbox = {
                x: inner.x,
                y: inner.y,
                width: outer.width / scaleMax,
                height: outer.height / scaleMax
            };
        canvas.viewbox(newViewbox);
    }
};

const initBpmn = (containerRef, setBpmn, setActivity) => {
    const bpmn = new BpmnViewer({
        container: containerRef.current,
        config: {
            bpmnRenderer: {
                defaultFillColor: "#FF0000",
                defaultStrokeColor: "red",
                defaultLabelColor: "green"
            }
        }
    });
    bpmn.on('element.click', (e) => {
        if (e.element.type === "bpmn:Task") {
            setActivity(e);
        }
    });
    setBpmn(bpmn);
    window.addEventListener("resize", () => fitViewport(bpmn));
}

const BpmnField = (props) => {
    const containerRef = useRef();
    const [activity, setActivity] = useState();
    const [bpmnObject, setBpmn] = useState();
    const value = props.record[props.source];
    const onActivityClick = useCallback((e) => {
        if (props.onActivityClick) {
            props.onActivityClick(e);
        }
    }, [props]);
    useEffect(() => {
        const bpmn: any = bpmnObject;
        if (bpmn) {
            bpmn.importXML(value).then(() => {
                const canvas = bpmn.get('canvas');
                const currentViewbox = canvas.viewbox();
                if (currentViewbox.width !== 0) {
                    fitViewport(bpmn);
                }
            });
        }
    }, [bpmnObject, value]);
    useEffect(() => initBpmn(containerRef, setBpmn, setActivity), [containerRef, setActivity]);
    useEffect(() => {
        if (activity) {
            onActivityClick(activity);
        }
    }, [activity, onActivityClick]);
    return <div className={`bpmn-container viewer ${props.className}`} style={props.style} ref={containerRef}></div>;
};

export default BpmnField;